import { Component, Input, OnInit } from '@angular/core';
import {
    ControlValueAccessor,
    FormControl,
    FormGroup,
    NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
    selector: 'app-checkbox',
    template: `
    <div class="form-group">
      <div class="form-check">
          <span class="form-check-input input-check">
              <span class="input-check__body">
                  <input
                      class="input-check__input pointer"
                      type="checkbox"
                      id="{{label}}"
                      [formControl]="control"
                  />
                  <span class="input-check__box"></span>
                  <app-icon
                      class="input-check__icon"
                      name="check-9x7"
                      size="9x7"
                  ></app-icon>
              </span>
          </span>
          <label style="font-size: 14px;" class="form-check-label" for="login-remember">{{
              label
          }}</label>
      </div>
    </div>
    `,
    styles: [
        `
            label {
              text-align: left;
            }

            .form-check {
                display: flex;
                align-items: flex-start;
            }
        `,
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CheckBoxComponent,
            multi: true,
        },
    ],
})
export class CheckBoxComponent implements ControlValueAccessor, OnInit {
    @Input() control = new FormControl();
    @Input() label: string;

    private onChange!: Function;
    private onTouched!: Function;
    disabled: boolean;

    ngOnInit(): void {
        this.control.valueChanges.subscribe((res) => {
            this.onChange(this.control.value);
        });
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value: any): void {
        if (value) {
          this.control.setValue(value, {emitEvent: false})
        }
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
